// import { ReceiptIcon } from "components/Icons";
// import WizardMovePayment from "./WizardMovePayment";

const getName = (record) => {
  return record.number;
};

function layout() {
  const ctxView = {
    model: "account.statement.line",
    row_selectable: false,
    form_action: ["edit"], // options: ['save', 'delete']
    table_action: ["edit"], // options: ['open', 'delete', 'edit', 'add']
    form_rec_name: getName,
    target: "booking",
    autoSave: true,
    reports: [
      {
        name: "account.statement.line",
        description: "Recibo de Pago",
        send_print: true,
        // send_email: "send_email",
      },
    ],
    fields: {
      statement: {
        type: "many2one",
        model: "account.statement",
        readOnly: true,
      },
      amount: { type: "numeric", readOnly: true },
      // booking: {
      //   type: "many2one",
      //   model: "hotel.booking",
      //   readOnly: true,
      // },
      // journal: {
      //   type: "many2one",
      //   model: "account.statement.journal",
      //   readOnly: true,
      // },
      date: {
        type: "date",
        readOnly: true,
      },
      number: {
        type: "char",
        readOnly: true,
      },
      party: {
        type: "many2one",
        model: "party.party",
        readOnly: true,
        attrs: ["id", "name"],
      },
      // modify_payment: {
      //   type: "button_wizard",
      //   Component: WizardMovePayment,
      //   color: "sky",
      //   // icon: <PlusCircleIcon className="h-5 w-5 fill-current" />,
      //   icon: <ReceiptIcon className="h-5 w-5 fill-current" />,
      // },
    },
    list: [
      { name: "number", width: "15%" },
      { name: "date", width: "15%" },
      { name: "statement", width: "30%" },
      { name: "amount", width: "10%" },
      { name: "party", width: "10%" },
    ],
    form: [
      { name: "statement" },
      {
        id: "number",
        grid: [{ name: "date" }, { name: "number" }],
        size: [1, 2],
      },
      { name: "amount" },
      { name: "party" },
      // { name: "move_payment" },
    ],
  };

  return ctxView;
}

export { layout };
